/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SchoolStatus {
  ENROLLED = 'ENROLLED',
  DROPPED = 'DROPPED',
  REST = 'REST',
  GRADUATED = 'GRADUATED',
}
